module.exports = __webpack_public_path__ + "static/media/Template_40.a3d37ba7.png";